import { render } from "./customer_add.vue?vue&type=template&id=684057ae&scoped=true"
import script from "./customer_add.vue?vue&type=script&lang=js"
export * from "./customer_add.vue?vue&type=script&lang=js"

import "./customer_add.vue?vue&type=style&index=0&id=684057ae&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684057ae"]])

export default __exports__